export const booleanToYesNo = (boolean) => boolean ? 'Yes' : 'No';

export const yesNoToBoolean = (value) => {
    if (typeof value === 'boolean') {
        return value;
    } else if (typeof value === 'string') {
        return value.toLowerCase() === 'yes';
    } else {
        return false;
    }
};




// WEBPACK FOOTER //
// ./src/utils/text.js